/* ss-collezione.js — filtri e ordine sulla collezione, senza ricaricare */
(function () {
  var sez = document.querySelector('[data-ss-col]');
  if (!sez) return;
  var griglia = sez.querySelector('[data-col-griglia]');
  var carte = [].slice.call(griglia.querySelectorAll('.ss-card'));
  if (!carte.length) return;

  var ETICHETTE = {
    pique: 'Piquet', maglina: 'Maglina', pannolenci: 'Pannolenci',
    imbottitura: 'Imbottitura', passamaneria: 'Passamaneria',
    merletto: 'Merletti', ciniglia: 'Ciniglia', softshell: 'Softshell'
  };
  function bello(chiave, v) {
    if (chiave === 'alt') return 'H ' + v + ' cm';
    if (ETICHETTE[v]) return ETICHETTE[v];
    return v.charAt(0).toUpperCase() + v.slice(1);
  }
  function tasto(el, fn) {
    el.addEventListener('click', fn);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fn(); }
    });
  }

  var scelte = { fam: [], col: [], alt: [], disp: false };
  var ordine = 'rilievo';

  /* valori presenti nella collezione, con quanti prodotti ciascuno */
  function raccogli(attr, multiplo) {
    var m = {};
    carte.forEach(function (c) {
      var v = (c.getAttribute(attr) || '').trim();
      if (!v) return;
      (multiplo ? v.split(/\s+/) : [v]).forEach(function (x) { if (x) m[x] = (m[x] || 0) + 1; });
    });
    return Object.keys(m).map(function (k) { return { v: k, n: m[k] }; })
      .filter(function (o) { return o.n >= 2; })
      .sort(function (a, b) { return b.n - a.n; });
  }

  function creaGruppo(chiave, attr, multiplo, ordinaNum) {
    var box = sez.querySelector('[data-p-' + chiave + ']');
    var voci = raccogli(attr, multiplo);
    if (ordinaNum) voci.sort(function (a, b) { return Number(a.v) - Number(b.v); });
    if (voci.length < 2) return;
    sez.querySelector('[data-tog="' + chiave + '"]').hidden = false;
    voci.forEach(function (o) {
      var el = document.createElement('span');
      el.className = 'ss-pill2';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.dataset.val = o.v;
      el.innerHTML = bello(chiave, o.v) + ' <i>' + o.n + '</i>';
      tasto(el, function () { commuta(chiave, o.v); });
      box.appendChild(el);
    });
    /* oltre 12 valori li tengo chiusi, altrimenti il filtro pesa piu della griglia */
    if (voci.length > 12) {
      var extra = [].slice.call(box.children, 12);
      extra.forEach(function (e) { e.hidden = true; });
      var apri = document.createElement('span');
      apri.className = 'ss-pill2 ss-pill2--piu';
      apri.setAttribute('role', 'button');
      apri.setAttribute('tabindex', '0');
      apri.textContent = 'Altri ' + extra.length;
      tasto(apri, function () {
        var chiusi = extra[0].hidden;
        extra.forEach(function (e) { e.hidden = !chiusi; });
        apri.textContent = chiusi ? 'Mostra meno' : 'Altri ' + extra.length;
      });
      box.appendChild(apri);
    }
  }

  function commuta(chiave, val) {
    var i = scelte[chiave].indexOf(val);
    if (i < 0) scelte[chiave].push(val); else scelte[chiave].splice(i, 1);
    sez.querySelectorAll('[data-p-' + chiave + '] .ss-pill2').forEach(function (e) {
      if (e.dataset.val) e.classList.toggle('is-on', scelte[chiave].indexOf(e.dataset.val) >= 0);
    });
    applica();
  }

  /* Senza un riscontro dentro il pannello sembra che il clic non faccia niente:
     la griglia sta piu in basso e il conteggio in alto resta fuori schermo. */
  sez.querySelectorAll('.ss-fil__pan').forEach(function (p) {
    if (p.dataset.pan === 'ord') return;
    var v = document.createElement('span');
    v.className = 'ss-fil__vedi';
    v.setAttribute('role', 'button');
    v.setAttribute('tabindex', '0');
    v.innerHTML = 'Vedi <b data-pan-n>0</b> <i>tessuti</i>';
    tasto(v, function () {
      apriPan(null);
      var g = sez.querySelector('[data-col-griglia]');
      if (g) g.scrollIntoView({ block: 'start', behavior: 'smooth' });
    });
    p.appendChild(v);
  });

  creaGruppo('fam', 'data-fam', false, false);
  creaGruppo('col', 'data-col', true, false);
  creaGruppo('alt', 'data-alt', false, true);

  /* un pannello per volta */
  function apriPan(nome) {
    sez.querySelectorAll('.ss-fil__pan').forEach(function (p) { p.hidden = p.dataset.pan !== nome; });
    sez.querySelectorAll('[data-tog]').forEach(function (t) {
      t.classList.toggle('is-aperto', t.dataset.tog === nome);
    });
  }
  sez.querySelectorAll('[data-tog]').forEach(function (t) {
    tasto(t, function () {
      var gia = t.classList.contains('is-aperto');
      apriPan(gia ? null : t.dataset.tog);
    });
  });

  var pDisp = sez.querySelector('[data-disp="1"]');
  tasto(pDisp, function () {
    scelte.disp = !scelte.disp;
    pDisp.classList.toggle('is-on', scelte.disp);
    applica();
  });

  sez.querySelectorAll('[data-ord]').forEach(function (o) {
    tasto(o, function () {
      ordine = o.dataset.ord;
      sez.querySelectorAll('[data-ord]').forEach(function (x) { x.classList.toggle('is-on', x === o); });
      sez.querySelector('[data-ord-et]').textContent = o.textContent.trim();
      apriPan(null);
      applica();
    });
  });

  var conta = sez.querySelector('[data-col-n]');
  var vuoto = sez.querySelector('[data-col-vuoto]');
  var barraSel = sez.querySelector('[data-sel]');

  function passa(c) {
    if (scelte.disp && c.getAttribute('data-disp') !== '1') return false;
    if (scelte.fam.length && scelte.fam.indexOf(c.getAttribute('data-fam')) < 0) return false;
    if (scelte.alt.length && scelte.alt.indexOf(c.getAttribute('data-alt')) < 0) return false;
    if (scelte.col.length) {
      var suoi = (c.getAttribute('data-col') || '').split(/\s+/);
      if (!scelte.col.some(function (x) { return suoi.indexOf(x) >= 0; })) return false;
    }
    return true;
  }

  /* le scelte attive restano visibili anche col pannello chiuso */
  function disegnaScelte() {
    barraSel.innerHTML = '';
    var quante = 0;
    ['fam', 'col', 'alt'].forEach(function (k) {
      var t = sez.querySelector('[data-tog="' + k + '"]');
      if (t) t.querySelector('[data-n]').textContent = scelte[k].length ? scelte[k].length : '';
      scelte[k].forEach(function (v) {
        quante++;
        var el = document.createElement('span');
        el.className = 'ss-scelto';
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');
        el.innerHTML = bello(k, v) + ' <b>&times;</b>';
        tasto(el, function () { commuta(k, v); });
        barraSel.appendChild(el);
      });
    });
    if (scelte.disp) quante++;
    if (quante) {
      var az = document.createElement('span');
      az.className = 'ss-azzera';
      az.setAttribute('role', 'button');
      az.setAttribute('tabindex', '0');
      az.textContent = 'Togli tutto';
      tasto(az, function () {
        scelte = { fam: [], col: [], alt: [], disp: false };
        sez.querySelectorAll('.ss-pill2.is-on[data-val]').forEach(function (e) { e.classList.remove('is-on'); });
        pDisp.classList.remove('is-on');
        applica();
      });
      barraSel.appendChild(az);
    }
    barraSel.hidden = !quante;
  }

  function applica() {
    var n = 0;
    carte.forEach(function (c) {
      var ok = passa(c);
      c.hidden = !ok;
      if (ok) n++;
    });
    conta.textContent = n;
    sez.querySelectorAll('[data-pan-n]').forEach(function (e) { e.textContent = n; });
    vuoto.hidden = n > 0;
    disegnaScelte();

    var vis = carte.filter(function (c) { return !c.hidden; });
    vis.sort(function (a, b) {
      if (ordine === 'prezzo-su') return Number(a.dataset.prezzo) - Number(b.dataset.prezzo);
      if (ordine === 'prezzo-giu') return Number(b.dataset.prezzo) - Number(a.dataset.prezzo);
      if (ordine === 'az') return a.dataset.nome.localeCompare(b.dataset.nome, 'it');
      if (ordine === 'za') return b.dataset.nome.localeCompare(a.dataset.nome, 'it');
      /* consigliati: prima i disponibili, poi l'ordine della collezione */
      var d = Number(b.dataset.disp) - Number(a.dataset.disp);
      return d || (Number(a.dataset.ord) - Number(b.dataset.ord));
    });
    vis.forEach(function (c) { griglia.appendChild(c); });
    carte.filter(function (c) { return c.hidden; }).forEach(function (c) { griglia.appendChild(c); });
  }

  applica();
})();
